/* Errors --------------------------------------> */
export const ERROR_BAD_SERVER = "Bad server response";
export const ERROR_UNKNOWN = "Unknown error";
export const ERROR_LOGIN_ERROR = "Incorrect username or password";

/* Statuses ------------------------------------> */
export const STATUS_ERROR = "error";
export const STATUS_LOADING = "loading";
export const STATUS_SUCCESS = "success";

/* Identity API Endpoints -------------------------------> */
export const API_LOGIN = "/account/login";
export const API_LOGOUT = "/account/logout";
export const API_KEEP_ALIVE = "/account/keep-alive";
export const API_REFRESH_TOKEN = "/account/refresh-token";
export const API_RESTORE_PASSWORD = "/account/restore/link";
export const API_RESTORE_RESET = "/account/restore/reset";
export const API_GET_PROFILE = "/account/profile";

/* Roles mapping --------------------------------> */
export const ROLES = {
  admin: "Admin",
  sales: "Sales",
  office_staff: "Office Staff"
};
